import PropTypes from 'prop-types';
import React from 'react';

import { Button, ButtonIcon, Footer, Page, PageContainer } from '@sonyged/ext-proc';

import Constants from '../../ice/fields/Constants';

export default class WeatherContent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={`proc-ice-field-content weather ${this.props.research ? 'research' : 'challenge'}`}>
        <Page.normal>
          <PageContainer.normal className={'flex flex-column'}>
            <div className="proc-contents">
              <div className={`title proc-medium-font ${this.props.research ? 'secondary100-color' : 'white-color'}`}>
                {this.props.title}
              </div>
              <div className={`sub-title proc-huge-font ${this.props.research ? 'secondary100-color' : 'white-color'}`}>
                {this.props.subTitle}
              </div>
              <div className={`weather-icon ${this.props.research ? 'research' : ''}`}>
                {Constants.getWetherSvg(this.props.iceCtx.weather)}
              </div>
              <div className={`temperature ${this.props.research ? 'secondary100-color' : 'white-color'}`}>
                {Constants.WEATHER_LABELS_ICE_ADV[this.props.iceCtx.weather]} <span className={'icon-proc-slash'} />
                <span className={'number'}>{this.props.iceCtx.temperature}</span>
                <span className={'postfix'}>&nbsp;度</span>
              </div>
              {this.props.onChange && <Button.normal onClick={this.props.onChange}>しらべる ひを かえる</Button.normal>}
            </div>
          </PageContainer.normal>
        </Page.normal>
        <Footer.nav shadow={false} navItem={this._renderPreviousButton()}>
          <Button.attention onClick={this._onNext.bind(this)}>つぎへ</Button.attention>
        </Footer.nav>
      </div>
    );
  }

  _renderPreviousButton() {
    if (!this.props.onPreviousClick) {
      return <span />;
    }
    return this.props.research ? (
      <Button.normal onClick={this._onPreviousClick.bind(this)}>
        <ButtonIcon.back />
      </Button.normal>
    ) : (
      <Button.dark onClick={this._onPreviousClick.bind(this)}>
        <ButtonIcon.back />
      </Button.dark>
    );
  }

  _onNext() {
    this.props.onNextClick();
  }

  _onPreviousClick() {
    this.props.onPreviousClick();
  }
}

WeatherContent.propTypes = {
  iceCtx: PropTypes.object,
  research: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  onNextClick: PropTypes.func,
  onPreviousClick: PropTypes.func,
  onChange: PropTypes.func,
};

WeatherContent.defaultProps = {};
